import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import ReactGA from 'react-ga';
import { mainTheme } from '../../theme';
import Header from '../../components/Header';
import HomePage from '../../components/HomePage';
import PageScroll from '../../components/PageScroll';

import Work from '../../containers/WorkContainer';
import AboutPage from '../../components/AboutPage';
import ContactPage from '../../components/ContactPage';

class Main extends Component {
  static propTypes = {
    appGetData: PropTypes.func.isRequired,
    data: PropTypes.shape({ work: PropTypes.array }),
    location: PropTypes.shape({ pathname: PropTypes.string.isRequired }),
    match: PropTypes.shape({ path: PropTypes.string.isRequired })
  };

  static getDerivedStateFromProps(nextProps) {
    const { data } = nextProps;
    return {
      data
    };
  }

  constructor(props) {
    super(props);
    this.state = { data: props.data, scrolling: false };
    this.timeout = 0;
  }

  componentDidMount() {
    const {
      data: { work }
    } = this.state;

    work.length < 1 && this.props.appGetData();
    ReactGA.initialize('UA-55067129-1');
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  stopScroll = () => {
    this.setState({ scrolling: false });
  };

  handleScroll = () => {
    const { scrolling } = this.state;
    window.clearTimeout(this.timeout);
    if (!scrolling) this.setState({ scrolling: true });
    this.timeout = window.setTimeout(this.stopScroll, 50);
  };

  render() {
    const {
      location,
      match: { path }
    } = this.props;
    const {
      data: { work }
    } = this.state;
    return (
      <ThemeProvider theme={mainTheme}>
        <div>
          <Header path={path} />
          <PageScroll location={location} pagePath="/home" path={path}>
            {() => <HomePage work={work} />}
          </PageScroll>
          {work &&
            work.length > 0 && (
              <PageScroll location={location} pagePath="/work" path={location.pathname}>
                {(lastPos, viewable) => <Work lastPos={lastPos} match={this.props.match} viewable={viewable} />}
              </PageScroll>
            )}
          <PageScroll location={location} pagePath="/about" path={location.pathname}>
            {(lastPos, viewable) => <AboutPage viewable={viewable} />}
          </PageScroll>
          <PageScroll location={location} pagePath="/contact" path={location.pathname}>
            {(lastPos, viewable) => <ContactPage viewable={viewable} />}
          </PageScroll>
        </div>
      </ThemeProvider>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main/index.js